import * as React from 'react'
import { ENTITY_TYPES } from '@sales-center/common'
import { ActivityHistoryContent } from './ActivityHistoryContent'

type Props = {
  entityId: number
  entityType: ENTITY_TYPES
  servicesCount: number
  agreementsCount: number
  paymentsCount: number
  appointments: any[]
  salesFunnelStageId: number
  assigneeId: string | null
}

export function ActivityHistory(props: Props) {
  return (
    <>
      <ActivityHistoryContent {...props} />
    </>
  )
}
